/* ltt-mobile-nav.js — behaviour for the fixed bottom tab bar.

   Two tabs do something other than navigate:
     · cart   — opens the drawer instead of loading /cart, but ONLY if the
                drawer element is actually present. The <a href="/cart"> stays
                in the markup so the tab still works with JS off or when the
                theme is in "cart page" mode.
     · search — handled by ltt-search-popup.js, which owns [data-ltt-search-open].

   The count bubble is refreshed from /cart.js after any cart mutation. Dawn
   re-renders the header bubble through section rendering, but this bar lives
   outside every section, so it would otherwise go stale. */
(function () {
  'use strict';
  if (window.lttTabbarBound) return;
  window.lttTabbarBound = true;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ltt-cart-open]');
    if (!trigger) return;

    var drawer = document.querySelector('cart-drawer');
    // No drawer on the page (cart-page mode, or the drawer failed to upgrade):
    // let the anchor do its job rather than trapping the tap.
    if (!drawer || typeof drawer.open !== 'function') return;

    event.preventDefault();
    drawer.open(trigger);
  });

  function refreshCount() {
    var bubbles = document.querySelectorAll('[data-ltt-tabbar-count]');
    if (!bubbles.length) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        bubbles.forEach(function (b) {
          b.textContent = cart.item_count;
          b.classList.toggle('is-empty', cart.item_count === 0);
        });
      })
      .catch(function () { /* a stale bubble is not worth surfacing an error */ });
  }

  // Dawn's cart JS publishes on this bus; fall back to watching the drawer's
  // own subtree if the pub/sub bundle is not on the page.
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, refreshCount);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      var drawer = document.querySelector('#CartDrawer');
      if (!drawer) return;
      new MutationObserver(refreshCount).observe(drawer, { childList: true, subtree: true });
    });
  }
})();
